import React from "react";

const LostPage = ({ notify }) => {
    return (
        <>
            <p>
                {/* Lost Page */}
                {/* This is the available lost page. */}
            </p>
        </>
    );
};

export default LostPage;
